import axiosOverlay from '../../js/axiosOverlay'

const state = {
    programmes: null,
    selectedProgramme: null
};

const getters = {
    programmes: state => state.programmes,
    selectedProgramme: state => state.selectedProgramme,
    getProgrammeById: (state) => (programmeID) => {
        if (state.programmes !== null) {
            return JSON.parse(state.programmes)?.find(programme => programme.id === programmeID) ?? null
        }
        return null;
    }
};

const mutations = {
    SET_PROGRAMMES(state, programmes) {
        state.programmes = programmes;
    },
    SET_SELECTED_PROGRAMME(state, programmeID) {
        state.selectedProgramme = programmeID;
    }
};

const actions = {
    async loadProgrammesFromAPI({ commit, state }) {
        if (state.programmes === null) {
            let config = {
                method: 'get',
                url: process.env.VUE_APP_API_URL + "/programmes",
                headers: { }
            };

            try {
                const response = await axiosOverlay(config);
                let result = JSON.stringify(response.data);
                commit('SET_PROGRAMMES', result);
            } catch (error) {
                console.log(error);
            }
        }
    },
    
    setSelectedProgramme({ commit }, programmeID) {
        commit('SET_SELECTED_PROGRAMME', programmeID);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
